<div class="a-titulo">
    SERVICIOS ADICIONALES
</div>
<div class="a-w1-column" style="padding: 20px;">
    <form [formGroup]="group">
        <div class="a-w1-row">
            <div class="a-w2" style="display: flex; gap: 20px;">
                <div class="a-w3">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <input formControlName="codigoope" type="text" pInputText class="w-full md:w-56" />
                        <label for="on_label">Código Operación</label>
                    </p-floatlabel>
                </div>
                <div class="a-w3">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <input formControlName="numeroope" type="text" pInputText class="w-full md:w-56" />
                        <label for="on_label">Número Operación</label>
                    </p-floatlabel>
                </div>
                <div class="a-w3">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <p-datepicker formControlName="fechaoperacion" appendTo="body" [showIcon]="true"
                            styleClass="w-full md:w-56" dateFormat="dd/mm/yy">
                        </p-datepicker>
                        <label for="on_label">Fecha Operación</label>
                    </p-floatLabel>
                </div>
            </div>
            <div class="a-w2" style="display: flex; gap: 20px;">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="listaCliente" optionLabel="nombre" formControlName="cliente"
                        optionValue="codigo" styleClass="w-full md:w-56" [filter]="true" [showClear]="true"
                        filterBy="nombre" [appendTo]="'body'">
                    </p-select>
                    <label for="on_label">Cliente</label>
                </p-floatlabel>
            </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
            <div class="a-w2" style="display: flex; gap: 20px;">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="listaAgenciaAduana" optionLabel="nombre" formControlName="aduana"
                        optionValue="codigo" styleClass="w-full md:w-56" [filter]="true" [showClear]="true"
                        filterBy="nombre" [appendTo]="'body'">
                    </p-select>
                    <label for="on_label">Agencia Aduana</label>
                </p-floatlabel>
            </div>
            <div class="a-w2" style="display: flex; gap: 20px;">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="listaAlmacen" optionLabel="nombre" formControlName="almacen"
                        optionValue="codigo" styleClass="w-full md:w-56" [filter]="true" [showClear]="true"
                        filterBy="nombre" [appendTo]="'body'">
                    </p-select>
                    <label for="on_label">Almacén</label>
                </p-floatlabel>
            </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
            <p-fieldset legend="Agregar Servicios" class="a-w1">
                <div class="a-w1" style="display: flex; gap: 20px;">
                    <div class="a-w4">
                        <div class="a-w1-row">
                            <p-floatlabel class="w-full md:w-56" variant="on">
                                <p-select [options]="listaServicio" optionLabel="nombre" formControlName="servicio"
                                    optionValue="codigo" styleClass="w-full md:w-56" [filter]="true" [showClear]="true"
                                    filterBy="nombre" [appendTo]="'body'">
                                </p-select>
                                <label for="on_label">Servicio</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-w1-row" style="padding-top: 20px;">
                            <p-button label="Buscar Tarifa" (onClick)="searchTarifa()"></p-button>
                            <p-button label="Agregar Servicio" (onClick)="AddServicio()"></p-button>
                        </div>
                    </div>
                    <div class="a-w4-diference">
                        <div class="a-w1">
                            <app-datatable [metadataTable]="metadataTableTarifa" [dataTable]="dataTableTarifa"
                                [filterGlobal]="true">
                            </app-datatable>
                        </div>
                    </div>
                </div>
            </p-fieldset>
        </div>
        <div class="a-w1-row" style="padding-top: 20px; justify-content: left;">
            <p-button label="Prefacturar" (onClick)="prefacturar()"></p-button>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
            <div class="a-w1">
                <app-datatable [metadataTable]="metadataTableServicios" [dataTable]="dataTableServicios"
                    [filterGlobal]="true" [rowEdit]="true" [rowDelete]="true" [key]="'key'">
                    <ng-template #addHeaderStart>
                        <th class="header">
                            <div class="items-header">
                                <span>Acción</span>
                            </div>
                        </th>
                    </ng-template>
                    <ng-template #addBodyStart let-row="row">
                        <td class="a-datatable-datos-body-accion row-space">
                            <p-checkbox [inputId]="row.id" />
                        </td>
                    </ng-template>
                </app-datatable>
            </div>
        </div>
        <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
            <p-button label="Guardar" (onClick)="TransaccionServAdicionales()"></p-button>
            <p-button label="Salir" (onClick)="salir()"></p-button>
        </div>
    </form>
</div>